/*
 * section-header-menu.js
 * Click-trigger dropdown behavior for _header-menu blocks (menu_dropdown_trigger=click).
 * Hover-trigger menus rely on pure CSS (:hover / :focus-within) — no JS.
 * Conditionally loaded by sections/header.liquid whenever the merchant has
 * at least one _header-menu block configured with a linklist.
 * Rule J9 compatible: IIFE-guarded, document-delegated, survives
 * shopify:section:load re-renders without re-binding.
 */
(function () {
  if (window.theme && window.theme.sectionHeaderMenuBound) return;
  window.theme = window.theme || {};
  window.theme.sectionHeaderMenuBound = true;

  const OPEN_CLASS = 'header-menu__item--open';

  function closeAll(exceptItem) {
    document.querySelectorAll('.' + OPEN_CLASS).forEach((item) => {
      if (item === exceptItem) return;
      item.classList.remove(OPEN_CLASS);
      const trigger = item.querySelector('[data-menu-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function toggleItem(item, trigger) {
    const isOpen = item.classList.contains(OPEN_CLASS);
    closeAll(isOpen ? null : item);
    if (isOpen) {
      item.classList.remove(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  function onClick(e) {
    const trigger = e.target.closest('[data-menu-dropdown-trigger]');
    if (trigger) {
      const menu = trigger.closest('[data-header-menu]');
      if (!menu || menu.getAttribute('data-menu-trigger-mode') !== 'click') return;
      const item = trigger.closest('[data-header-menu-item]');
      if (!item) return;
      e.preventDefault();
      toggleItem(item, trigger);
      return;
    }
    // Outside click — close any open click-trigger dropdowns.
    if (!e.target.closest('[data-menu-trigger-mode="click"] .' + OPEN_CLASS)) {
      closeAll(null);
    }
  }

  function onKeydown(e) {
    if (e.key !== 'Escape') return;
    const openItem = document.querySelector('[data-menu-trigger-mode="click"] .' + OPEN_CLASS);
    if (!openItem) return;
    const trigger = openItem.querySelector('[data-menu-dropdown-trigger]');
    openItem.classList.remove(OPEN_CLASS);
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
  }

  /*
   * L3 flyout overflow detection. The L3 dropdown normally flies out to the
   * right of its L2 parent (inset-inline-start: 100%). If that would spill
   * past the viewport's right edge we toggle .header-menu__dropdown--level-3--flip-left
   * which flips the anchor to inset-inline-end: 100% (flies out to the left).
   * Pure CSS can't do viewport-aware flipping, so this is the minimum JS needed.
   */
  const FLIP_LEFT_CLASS = 'header-menu__dropdown--level-3--flip-left';
  const SAFETY_PAD_PX = 8;

  function evaluateFlip(subitem) {
    const menu = subitem.closest('[data-header-menu]');
    if (!menu) return;
    const panel = subitem.querySelector(':scope > .header-menu__dropdown--level-3');
    if (!panel) return;
    // Temporarily clear flip so we measure the default (right-flyout) position.
    panel.classList.remove(FLIP_LEFT_CLASS);
    const subRect = subitem.getBoundingClientRect();
    const panelWidth = panel.offsetWidth || 220;
    const projectedRight = subRect.right + panelWidth + SAFETY_PAD_PX;
    if (projectedRight > window.innerWidth) {
      panel.classList.add(FLIP_LEFT_CLASS);
    }
  }

  function onPointerOver(e) {
    const subitem = e.target.closest('[data-header-menu-subitem]');
    if (!subitem) return;
    evaluateFlip(subitem);
  }

  function onFocusIn(e) {
    const subitem = e.target.closest('[data-header-menu-subitem]');
    if (!subitem) return;
    evaluateFlip(subitem);
  }

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKeydown);
  document.addEventListener('pointerover', onPointerOver);
  document.addEventListener('focusin', onFocusIn);
})();
